<template>
    <a
        v-if="to && /http/i.test(to)"
        v-bind:class="style"
        :href="to"
        :target="isExternalLink(to) ? '_blank' : '_self'"
    >
        <img
            v-if="image"
            :src="image?.url"
            :alt="image?.alt"
        />
        <span v-else>
            {{ label }}
        </span>
    </a>
    <a
        v-else-if="modal"
        @click.prevent="showModal"
        v-bind:class="style"
        :data-id="id"
        href="#"
        :target="isExternalLink(to) ? '_blank' : '_self'"
    >
        {{ label }}
    </a>
    <router-link
        v-else-if="to"
        v-bind:class="style"
        :to="to"
    >
        {{ label }}
    </router-link>
    <a
        v-else
        @click.prevent="action"
        v-bind:class="style"
        :data-id="id"
        href="#"
        :target="isExternalLink(to) ? '_blank' : '_self'"
    >
        {{ label }}
    </a>
</template>

<script>
import { useModalStore } from '@/stores/index';

export default {
    name: 'LinkButton',
    props: {
        action: Function,
        to: String,
        label: String,
        style: String,
        id: String,
        modal: Object,
        image: Object
    },
    methods: {
        showModal() {
            const modalStore = useModalStore();
            modalStore.content = this.modal
            modalStore.toggleModal()
        },
        isExternalLink(url) {
            if (!url) {
                return;
            }

            return url.startsWith('http');
        }
    }
}
</script>

<style lang="scss" scoped>
a {
    color: inherit;
    text-decoration: none;
    vertical-align: middle;
}

a.bold_link {
    font-weight: 800;
}

a.primary_button,
a.secondary_button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 24px;
    border-radius: 999px;
    font-weight: 700;
    font-size: 15px;
    line-height: 1;
    letter-spacing: 0.2px;
    border: 1px solid transparent;
    transition: transform 180ms cubic-bezier(0.2, 0.8, 0.3, 1),
                box-shadow 180ms ease, background-color 180ms ease;
}

a.primary_button {
    color: #fff;
    background-color: var(--bzioup-color-pink);
}

a.primary_button:hover {
    background-color: var(--bzioup-color-pink-deep);
}

a.secondary_button {
    color: var(--bzioup-color-Z);
    background-color: transparent;
    border-color: rgba(0, 0, 0, 0.18);
}

a.primary_button:hover,
a.secondary_button:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(218, 138, 139, 0.28);
}

a.primary_button:active,
a.secondary_button:active {
    transform: translateY(0) scale(0.98);
    box-shadow: none;
}

a + a {
    margin-left: 12px;
}
</style>
